import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";

export enum PartLocationChangeType {
  Placed,
  Moved,
  Removed,
}

export interface IPartLocationHistoryEntry {
  id: string;
  changedOn: string;
  changeType: PartLocationChangeType;
  fromWarehouseLocationId: string | null;
  /** Null when the location has since been deleted — the id is still returned. */
  fromLocationName: string | null;
  toWarehouseLocationId: string | null;
  toLocationName: string | null;
  partStatus: number;
  userId: string | null;
}

export interface IPartLocationHistory {
  partDataId: string;
  tagNumber: string | null;
  currentWarehouseLocationId: string | null;
  currentLocationName: string | null;
  lastKnownWarehouseLocationId: string | null;
  lastKnownLocationName: string | null;
  entries: IPartLocationHistoryEntry[];
}

interface IPartLocationHistoryResponse {
  success: boolean;
  message: string;
  data: IPartLocationHistory;
}

export default function usePartLocationHistory(
  partId: string | undefined,
  componentName = "usePartLocationHistory"
) {
  const { get } = useApiHelper(apiConfig(componentName));

  const partLocationHistory = useQuery({
    queryKey: ["partLocationHistory", partId],
    queryFn: () => get<IPartLocationHistoryResponse>(`/part/${partId}/location-history`),
    enabled: !!partId,
    refetchOnWindowFocus: false,
  });

  return { partLocationHistory };
}
